import React from "react";
import "../styles/footer.css";
import LogoFooter from "../assets/logo_footer.png";
import { FaInstagram, FaGoogle, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer_container">
        <div className="footer-section">
          <h3>Navegação</h3>
          <ul>
            <li>
              <Link className="linkFooter" to="/">
                Início
              </Link>
            </li>
            <li>
              <Link className="linkFooter" to="/todos-imoveis">
                Todos Imóveis
              </Link>
            </li>
            <li>
              <Link className="linkFooter" to="/lancamentos-planta">
                Lançamento na Planta
              </Link>
            </li>
            <li>
              <Link className="linkFooter" to="/comprar-imovel">
                Comprar Imóvel
              </Link>
            </li>
            <li>
              <Link className="linkFooter" to="/alugar-imovel">
                Alugar Imóvel
              </Link>
            </li>
            <li>
              <Link className="linkFooter" to="/fale-conosco">
                Fale Conosco
              </Link>
            </li>
            <li>
              <Link className="linkFooter" to="/corretores">
                Corretores
              </Link>
            </li>
            <li>
              <Link className="linkFooter" to="/panel/dashboard">
                Acesso
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-logo">
          <img src={LogoFooter} alt="Senna Viannini" />
          <h3 className="creciSenna">CRECI PJ: <span>9568</span></h3>
        </div>

        <div className="footer-section">
          <h3>Redes Sociais</h3>
          <div className="social-icons">
            <a
              href="https://www.instagram.com/sennaviannini/"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.google.com/search?q=senna+viannini&sourceid=chrome&ie=UTF-8"
              target="_blank"
              rel="noreferrer"
            >
              <FaGoogle />
            </a>
            <a
              href="https://wa.me/5532999956939?text=Ol%C3%A1%2C%20venho%20diretamente%20do%20link%20de%20d%C3%BAvidas%20do%20site."
              target="_blank"
              rel="noreferrer"
            >
              <FaWhatsapp />
            </a>
          </div>
          <div className="contact-info">
            <p>
              <strong>Contato</strong>
            </p>
            <p>32 9.9900.3833 (Vitor Viannini)</p>
            <p>32 9.9956.6939 (Aluízio Senna)</p>
            <p>contato@sennaviannini.com.br</p>
            <p>
              <strong>Endereço</strong>
            </p>
            <p>Av. Dr. José Caetano de Carvalho, 698</p>
            <p>Centro, São João del Rei - MG</p>
            <p>CEP: 36307-251</p>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <a href="https://grupotacco.com.br" target="_blank" rel="noreferrer">
          Realização: <strong>Grupo Tacco</strong>
        </a>

        <p style={{ textAlign: "center" }}>
          Copyright © 2024 - {new Date().getFullYear()}{" "}
          <span>Senna Viannini</span>. <br></br>Todos os direitos reservados.
        </p>

        <a href="https://e2tcode.com" target="_blank" rel="noreferrer">
          Desenvolvimento: <strong>E2T Code</strong>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
